import { Component, OnInit } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { NotificationService } from "./notifications.service";
import { AppService } from "src/app/app.service";
import { Observable } from "rxjs";
import { Global } from "src/global";
import { Router } from "@angular/router";

@Component({
  selector: "app-notifications",
  templateUrl: "./notifications.component.html",
  styleUrls: ["./notifications.component.scss"],
})
export class NotificationsComponent implements OnInit {
  notifications: any[] = [];
  incomplete: any[] = [];
  lessonCount: number = 0;
  incompleteCount: number = 0;
  firstTwoNotifications: any[] = [];
  firstTwoIncomplete: any[] = [];
  User_GUID: string;
  callingFilter: string;
  showBadge: boolean = false;

  constructor(
    public modalController: ModalController,
    private notificationService: NotificationService,
    private appservice: AppService,
    public globals: Global,
    private router: Router
  ) {}

  ngOnInit() {
    this.notificationList();
    this.incompleteLessonList();
  }

  dismissModal() {
    this.modalController.dismiss();
  }

  getItalicLessons(lessons: any[]): string {
    return lessons.map((lesson) => `<i>"${lesson}"</i>`).join(" and ");
  }

  navigateToURL(url: string) {
    this.router.navigate([url]);
  }

  notificationList() {
    const formData: FormData = new FormData();
    formData.append("User_GUID", this.globals.XRSUser.GUID);
    formData.append("User_Token", this.globals.XRSUser.UserToken);

    this.appservice.GetNotificationList(formData).subscribe((res) => {
      
      try {
        this.notifications = JSON.parse(res);
        this.lessonCount = this.notifications.length;
        this.firstTwoNotifications = this.notifications.slice(0, 2);
        this.updateBadgeStatus();
      } catch (e) {
        console.error(e);
      }
    });
  }

  incompleteLessonList() {
    const formData: FormData = new FormData();
    formData.append("User_GUID", this.globals.XRSUser.GUID);
    formData.append("User_Token", this.globals.XRSUser.UserToken);

    this.appservice.GetIncompleteLessonList(formData).subscribe((res) => {
      
      try {
        this.incomplete = JSON.parse(res);
        this.incomplete = this.incomplete.map(
          (lesson) => lesson.LessonDescription
        );
        this.incompleteCount = this.incomplete.length;
        this.firstTwoIncomplete = this.incomplete.slice(0, 2);
        this.updateBadgeStatus();
      } catch (e) {
        console.error(e);
      }
    });
    
  }

  updateBadgeStatus() {
    const showBadge =
      (this.notifications && this.notifications.length > 0) ||
      (this.incomplete && this.incomplete.length > 0) ||
      (this.notifications &&
        this.notifications.length > 0 &&
        this.incomplete &&
        this.incomplete.length > 0);
    this.notificationService.setBadgeState(showBadge);
  }
}
